// extracted by mini-css-extract-plugin
export default {"fullWidthItem":"styleModule_fullWidthItem__CMnYH","title":"styleModule_title__zLJ7e","content":"styleModule_content__M34si","arrow":"styleModule_arrow__E+6AV"};